module.exports = __webpack_public_path__ + "img/hr-dark-mud-decal-25.69871585.png";